<template>
  <q-field />
</template>

<style lang="scss" scoped>
.q-field {
  padding-bottom: 0;
  max-width: 400px;
}

:deep(.q-field__control) {
  display: none;
}

:deep(.q-field__bottom) {
  position: relative;
  padding-top: 0;
  transform: none;
  min-height: 0;
}
</style>
